<div>
    <h2 *ngIf="title">{{title}}</h2>
    <!-- Used when we want to inject a custom title content -->
    <ng-content select="app-title"></ng-content>
    
   <div>
     <ng-content></ng-content>
   </div>

</div>